import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=1a215f6a&scoped=true"
import script from "./QuestionHeader.vue?vue&type=script&lang=js"
export * from "./QuestionHeader.vue?vue&type=script&lang=js"
import style0 from "./QuestionHeader.vue?vue&type=style&index=0&id=1a215f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a215f6a",
  null
  
)

export default component.exports